module.exports = __webpack_public_path__ + "assets/img/wa_head.4f250acc.svg";